export const platformSettings = {
    GET_PLATFORM_SETTINGS: "GET_PLATFORM_SETTINGS",
    GET_PLATFORM_SETTINGS_SUCCESS: "GET_PLATFORM_SETTINGS_SUCCESS",
    GET_PLATFORM_SETTINGS_ERRORS: "GET_PLATFORM_SETTINGS_ERRORS",
};

